import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

function InvoiceNFeDetailsPage() {
  const history = useHistory();
  const match = useRouteMatch<{ invoiceId: string }>();
  const { invoiceId } = match.params;

  useEffect(() => {
    if (match.isExact) {
      history.push(
        `/app/fiscal/invoice/${InvoiceType.NFE}/${invoiceId}/noteItens`,
      );
    }
  }, [match]);

  return null;
}

export default InvoiceNFeDetailsPage;
